import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ParentSelectorFacade } from "@webapp/okrs/services/parent-selector-facade.service";
import { SearchFacade } from "@webapp/search/services/search-facade.service";
import { MultiSelectorModule } from "@webapp/shared/components/multi-selector/multi-selector.module";
import { ParentSelectorComponent } from "./parent-selector.component";

@NgModule({
  imports: [CommonModule, MultiSelectorModule],
  providers: [ParentSelectorFacade, SearchFacade],
  declarations: [ParentSelectorComponent],
  exports: [ParentSelectorComponent],
})
export class ParentSelectorModule {}
